/* eslint-disable @typescript-eslint/no-useless-constructor */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable, signal } from '@angular/core';
import {
  EMAIL_VERIFY_PAYLOAD,
  MOBILE_VERIFY_PAYLOAD,
} from '../verify/otp-verify/otp-verify.constant';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignupService {
  emailOtp = signal<Partial<EMAIL_VERIFY_PAYLOAD> | null>(null);
  email = signal<string | null>(null);
  mobileOtp = new BehaviorSubject<MOBILE_VERIFY_PAYLOAD | null>(null);
  constructor() {}
}
